import { BarChart } from '@mantine/charts';

const BarChartDefaults = BarChart.extend({
  defaultProps: {
    withTooltip: false,
    orientation: 'horizontal',
    tickLine: 'y',
    withLegend: false,
    gridAxis: 'x',
    withXAxis: true,
    withYAxis: true,
  },
  classNames: {},
});

export { BarChart, BarChartDefaults };
